//imports
import {
    TRANSACTIONS_RESULT_REQUEST,
    TRANSACTIONS_RESULT_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    transactions: null,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TRANSACTIONS_RESULT_REQUEST:
            return { ...state, loading: true }
        case TRANSACTIONS_RESULT_RESULT:
            return { ...state,
                loading: false,
                transactions: action.payload.oldNextToken
                    ? [...state.transactions, ...action.payload.transactions]
                    : action.payload.transactions,
                nextToken: action.payload?.nextToken }
        case CLEAR_REDUX:
            return ["", "TRANSACTIONS_RESULT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
